module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.compteur",
      modifiers: {
        "compteur": true
      }
    }],
    staticStyle: {
      "margin-bottom": "5px",
      "margin-top": "0",
      "font-size": "14px",
      "font-weight": "600"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "count",
    attrs: {
      "id": "cntdwn"
    }
  }), _vm._v(" "), _c('table', {
    attrs: {
      "width": "265",
      "border": "0",
      "align": "center",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "65",
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.jours",
      modifiers: {
        "jours": true
      }
    }],
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "85",
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.heures",
      modifiers: {
        "heures": true
      }
    }],
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50",
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.minutes",
      modifiers: {
        "minutes": true
      }
    }],
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.secondes",
      modifiers: {
        "secondes": true
      }
    }],
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6cd7f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompteARebours.vue
// module id = 52
// module chunks = 0